import React, {Fragment, useEffect, useRef, useState} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import {getRenderJobCartItemsGroupObjects} from "../../jobEditPopup/jobEditPopupFunctions";
import {getEditPopupJobResponse} from "../../jobEditPopup/jobEditAsyncActions";
import useFetchJobData from "../../jobEditPopup/useFetchJobData";
import {getCurrencySymbol} from "../../../../utilities";
import JobEditIframe from "../../jobEditPopup/JobEditIframe";
import {DASHBOARD_MESSAGING_ACTIONS, sendIframePostMessage} from "../../jobEditPopup/jobIframeMessaging";
import {getParsedJobOrder, getReferralAmount} from "../jobOrderFunctions";
import {setJobEditPopupIframeWaitingReceipt} from "../../jobEditPopup/jobEditActions";


const JobPurchaseOrder = (props) => {

  const {job, jobTotal, intl, jobCartItems, getEditPopupJobResponse, jobEditPopupIframeWaitingReceipt,
    setJobEditPopupIframeWaitingReceipt} = props;

  const loading = useFetchJobData(intl, getEditPopupJobResponse);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const iframeElement = useRef();

  const setLoading = (event) => {
    if (event && event.data && (event.data.action === DASHBOARD_MESSAGING_ACTIONS.jobDataAfterUpdate) && !iframeLoaded) {
      setIframeLoaded(true);
    }
  }

  useEffect(() => {
    if (jobEditPopupIframeWaitingReceipt && iframeLoaded) { // button is clicked and iframe is loaded! request receipt
      const jobOrder = getParsedJobOrder(job);
      sendIframePostMessage(iframeElement.current, {
        action: DASHBOARD_MESSAGING_ACTIONS.setReferralData,
        payload: {
          referralPercent: jobOrder.referralPercent,
          referralAmount: getReferralAmount(jobOrder, jobTotal),
        }
      })
    }
    return () => {
      if (jobEditPopupIframeWaitingReceipt && iframeLoaded) {
        setJobEditPopupIframeWaitingReceipt(false)
      }
    }
  }, [iframeLoaded, jobEditPopupIframeWaitingReceipt]);

  useEffect(() => {
    window.addEventListener("message", setLoading);
    return () => {
      window.removeEventListener("message", setLoading);
    }
  }, [])

  return (
    <div className={"flex flex--column relative job-payment__content flex-item"
      + (loading ? "" : " scrollbar3 mr-075 pr-075")}>
      <JobEditIframe intl={intl} ref={iframeElement}/>
      {loading
        ? <div className="ui-loader ui-loader--medium"/>
        : getRenderJobCartItemsGroupObjects(jobCartItems, null, "").map((groupObject, quoteIndex) => {
        return (
          <div key={groupObject.groupName + quoteIndex} className="mb-15">
            <div className="p-05 pl-1 pr-1 bg-littlegray color-textgray font--16 bold">{groupObject.groupName}</div>
            <ul className="fix-ul grid job-board-edit-popup__grid job-board-edit-popup__grid--no-check bold font--14 color-textgray text-left">
              {groupObject.cartItems.map((jobCartItem) => {
                return (
                  <li key={jobCartItem.id} className="mb-05 job-board-edit-popup__grid-row">
                    <div
                      className="flex flex--center flex--start text-overflow pb-0 pl-1 pr-1 job-board-edit-popup__grid-cell border-box">
                      <p className="m-0 pr-two-lines">
                        {jobCartItem.cartFeature.partName}{jobCartItem.cartFeature.sku ? " (sku: " + jobCartItem.cartFeature.sku + ")" : null}
                      </p>
                    </div>
                    <div
                      className="flex flex--bottom flex--bottom p-05 pl-1 pr-1 job-board-edit-popup__grid-cell border-box">
                      {((jobCartItem.units || jobCartItem.unit) === "No Quantity") ? null : (
                        <Fragment>
                          {jobCartItem.units || jobCartItem.unit ? (jobCartItem.units || jobCartItem.unit) + ": " : ""}
                          {jobCartItem.quantity}
                        </Fragment>
                      )}
                    </div>
                    <div
                      className="flex flex--bottom flex--end p-05 pl-1 pr-1 job-board-edit-popup__grid-cell border-box">
                      {loading
                        ? <div className="ui-loader ui-loader--small"/>
                        : getCurrencySymbol(jobCartItem.currency) + jobCartItem.calculatedCost}
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        )
      })}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {job, jobTotal, jobCartItems, jobEditPopupIframeWaitingReceipt} = store.jobEditPopupState;

  return {
    job,
    jobTotal,
    jobCartItems,
    jobEditPopupIframeWaitingReceipt
  };
};

const mapDispatchToProps = {
  getEditPopupJobResponse,
  setJobEditPopupIframeWaitingReceipt,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(JobPurchaseOrder)
)
